<template>
  <div class="card relative z-2" style="">
    <Menubar :model="(items.concat(privacyItems as []) as MenuItem[])">
      <template #start>
        <a href="/" style="margin-right:1em;"><img alt="Berkstresser LLC home" src="@/assets/dusty.gif" height="40" class="mr-2" /></a>
      </template>
      <template #item="{ label, item, props, root }">
        <router-link v-if="item.route" v-slot="routerProps" :to="item.route" custom>
          <a :href="routerProps.href" v-bind="props.action">
            <span v-bind="props.icon" />
            <span v-bind="props.label">{{ label }}</span>
          </a>
        </router-link>
        <a v-else :href="item.url" :target="item.target" v-bind="props.action">
          <span v-bind="props.icon" />
          <span v-bind="props.label">{{ label }}</span>
          <span :class="[root ? 'pi pi-fw pi-angle-down' : 'pi pi-fw pi-angle-right']" v-bind="props.submenuicon" />
        </a>
      </template>
    </Menubar>
    
      <router-view />
      <div style="max-width: 100em;width:95%;">
      <footer>
        <br><br>
        <hr>
        <i>Providing a quality, personalized education to those who are academically able but inadequately served by
          the
          public school system</i>

      </footer>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'app',
  data() {
    return {
      privacyItems: [
        {
          label: 'Privacy & Terms of Service',
          route: '/privacy'
        }
      ],

      items: [
        {
          label: 'Home',
          route: '/'
        },
        {
          label: 'Pricing',
          route: '/pricing'
        },
        {
          label: 'About Us',
          route: '/about_us'
        },
        {
          label: 'FAQ',
          route: '/faq'
        },
      ]
    }
  }
}
</script>

<script lang="ts" setup>
import Menubar from 'primevue/menubar';
import 'primeicons/primeicons.css';
import { MenuItem } from 'primevue/menuitem';
</script>
